import "styles/main.scss";
import "@ic-anywhere/ic-components/styles.css";
import { App } from "components/App/App";
import { createRoot } from "react-dom/client";

const sgConnectWidget = document.body.querySelector("sgwt-connect") as any;
if (sgConnectWidget === null) {
  console.error("The widget sgwt-connect was not found on the page");
} else if (sgConnectWidget.sgwtConnect) {
  login();
} else {
  sgConnectWidget.addEventListener("sgwt-connect--ready", login);
}

function login(): void {
  const sgwtConnect = sgConnectWidget.sgwtConnect;
  sgConnectWidget.removeEventListener("sgwt-connect--ready", login);
  if (sgwtConnect.getAuthorizationError()) {
    console.error({
      source: "authorization",
      error: `Authorization failed with error ${sgwtConnect.getAuthorizationError()}`,
    });
  } else if (sgwtConnect.isAuthorized()) {
    const rootElement = document.getElementById("root");
    if (rootElement) {
      createRoot(rootElement).render(<App />);
    }
  } else {
    sgwtConnect.requestAuthorization();
  }
}
